import { useState } from 'react'
import { useSnackbar } from 'notistack'
import { exportInit, exportDownloadUrl } from 'models/orderExport'
import printStyles from '../assets/css/print.css?inline'

export const useOrderExport = () => {
    const { enqueueSnackbar } = useSnackbar()
    const [loading, setLoading] = useState(false)

    const exportOrders = async ({ format, type = 'all', orderId = null, filters = {} }) => {
        try {
            setLoading(true)

            const res = await exportInit({
                format,
                type,
                order_id: orderId,
                filters,
            })

            const key = res.key
            if (!key) throw new Error('No export key received')

            window.open(exportDownloadUrl(key), '_blank', 'noopener,noreferrer')

            enqueueSnackbar(`${format.toUpperCase()} export started`, {
                variant: 'success',
                autoHideDuration: 2000,
            })

        } catch (err) {
            enqueueSnackbar(err?.message || 'Export failed', {
                variant: 'error',
                autoHideDuration: 2500,
            })
        } finally {
            setLoading(false)
        }
    }

    return { exportOrders, loading }
}

export function usePrint(ref, title = 'Invoice') {
    return () => {
        if (!ref.current) {
            console.warn('usePrint: ref.current is null')
            return
        }

        const clone = ref.current.cloneNode(true)
        clone.id = '__print_clone__'
        clone.style.cssText = '' 

        const style = document.createElement('style')
        style.id = '__print_style__'
        style.innerHTML = `
            @media print {
                @page {
                    size: A4;
                    margin: 15mm;
                }

                /* Hide the real page */
                body > *:not(#__print_clone__):not(#__print_style__) {
                    display: none !important;
                }

                /* Show only our clone */
                #__print_clone__ {
                    display: block !important;
                    visibility: visible !important;
                    position: static !important;
                    width: 100% !important;
                    margin: 0 !important;
                    padding: 0 !important;
                    background: #fff !important;
                    -webkit-print-color-adjust: exact !important;
                    print-color-adjust: exact !important;
                }

                #__print_clone__ * {
                    visibility: visible !important;
                }

                ${printStyles}
            }

            /* Hide the clone from the normal screen view */
            @media screen {
                #__print_clone__ {
                    display: none !important;
                }
            }
        `

        document.head.appendChild(style)
        document.body.appendChild(clone)

        const prevTitle = document.title
        document.title = title

        window.print()

        document.title = prevTitle
        document.getElementById('__print_clone__')?.remove()
        document.getElementById('__print_style__')?.remove()
    }
}